import { memo, MouseEvent } from "react";
import * as BaseIcons from "./IconSvgs/BaseIconSvgs";
// import * as CountryIcons from './IconSvgs/CountryIconSvgs';
// import * as MiscellaneousIcons from './IconSvgs/MiscellaneousIconSvgs';
// import * as PaymentIcons from './IconSvgs/PaymentIconSvgs';
// import * as ThumbnalIcons from './IconSvgs/ThumbnailSvgs';
import styles from "./Icon.module.scss";
import classNamesHelper from "../shared/classNamesHelper";

const Icons = { ...BaseIcons };

export type IconStrings = keyof typeof Icons;

export interface IconProps {
  name: IconStrings;
}
export interface SvgIconConstituentValues {
  id?: string;
  size?: "xxs" | "xs" | "sm" | "md" | "lg";
  color?: string;
  stroke?: string;
  className?: string;
  role?: string;
  onClick?: (e: MouseEvent<SVGSVGElement | HTMLButtonElement> | React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<SVGSVGElement>) => void;
  tabIndex?: number;
  title?: string;
}
const defaultIconSize = "sm";

const Icon = memo(
  ({ name, color, size = defaultIconSize, className, ...props }: IconProps & SvgIconConstituentValues): JSX.Element => {
    const CustomIcon = Icons[name];
    const checkIfBaseIcon = () => {
      const baseIcons = Object.assign({}, BaseIcons);
      if (baseIcons.hasOwnProperty(name)) return true;
      else return false;
    };

    return (
      <CustomIcon
        id={props.id}
        role={props.role || "icon"}
        stroke={checkIfBaseIcon() ? color : undefined}
        className={classNamesHelper([
          styles.icon,
          className,
          styles[size],
          !className && !color && checkIfBaseIcon() && styles.defaultColor,
        ])}
        onClick={props.onClick}
        title={props.title}
        data-icon={name}
        aria-label={props.title || name}
      />
    );
  }
);

export default Icon;
